import { all, takeLatest, put } from 'redux-saga/effects';
import {
    GET_SETTINGS,
    UPDATE_SETTINGS_QUESTION_ANSWERS,
    CHANGE_FEEDBACK
} from './constants';

import {
    requestSettings,
    requestUpdateSettingsQuestion,
} from './api';
import {
    getSettignsSuccess,
    updateSettingsQuestionAnswersSuccess,
    changeFeedbackSuccess
} from './actions';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{settings: *, type: string}>>}
 */
function* getSettings( actionObj ) {
    const settings = yield requestSettings( actionObj.id );
    if ( settings ) {
        yield put( getSettignsSuccess( settings ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{id: *, type: string, value: *}>>}
 */
function* updateSettingsQuestion( actionObj ) {
    const updateQuestionAnswer = yield requestUpdateSettingsQuestion( actionObj.id, actionObj.value );

    if ( updateQuestionAnswer ) {
        yield put( updateSettingsQuestionAnswersSuccess( actionObj.id, updateQuestionAnswer ) );
    }
}

/**
 *
 * @param val
 * @returns {IterableIterator<PutEffect<{type: string, value: *}>>}
 */
function* changeFeedback( val ) {
    if ( val ) {
        yield put( changeFeedbackSuccess( val.value ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchSettings() {
    yield takeLatest( GET_SETTINGS, getSettings );
    yield takeLatest( UPDATE_SETTINGS_QUESTION_ANSWERS, updateSettingsQuestion );
    yield takeLatest( CHANGE_FEEDBACK, changeFeedback );
}

/**
 *
 * @returns {IterableIterator<AllEffect<IterableIterator<ForkEffect>>>}
 */
function* settingsSaga() {
    yield all( [
        watchSettings()
    ] );
}

export default settingsSaga;
